import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

// Required for side-effects
require("firebase/firestore");

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBeLz9_J1KAf8Pl8ktx9Pxb3TRo4JOa6qQ",
  authDomain: "rufus-vue.firebaseapp.com",
  databaseURL: "https://rufus-vue.firebaseio.com",
  projectId: "rufus-vue",
  storageBucket: "rufus-vue.appspot.com",
  messagingSenderId: "620947718667"
};
firebase.initializeApp(config);

// Initialize Cloud Firestore through Firebase
const auth = firebase.auth();
const db = firebase.firestore();
const functions = firebase.functions();

window.auth = auth
window.db = db
window.functions = functions

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
